var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1InternetTvBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 29v4.68a5 5 0 01-5 5c-.53 0-1.055-.08-1.56-.24A5 5 0 0118 33.6V29H6v34h63V29H28zm37 30H10V42h55v17zm-12-8h-3v-5h11v5h-3v4h-5v-4zm-15 0h-3v-5h11v5h-3v4h-5v-4zm-12 4h-4v-9h4v9zm-5-21.4V8.33a2 2 0 011.35-2c.21-.067.43-.1.65-.1a2 2 0 012 2v25.45a2 2 0 01-2 2c-.22 0-.44-.033-.65-.1A2 2 0 0121 33.6zM18 55h-4v-9h4v9z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Internet_TV_box.5601d211.svg";
export { SvgH1InternetTvBox as ReactComponent };